import NavBreadcrumb from '../nav-main/src/v2/nav-breadcrumb';

/* istanbul ignore next */
NavBreadcrumb.install = function(Vue) {
  Vue.component(NavBreadcrumb.name, NavBreadcrumb);
};

export default NavBreadcrumb;
